import { LINKS } from "@silo/types";
import { Pill } from "../pill";
import { ExternalLink } from "./external-link";
import { useDescriptionVariant } from "../description/use-description-variant";
import { match } from "ts-pattern";
import { TooltipDescription } from "../description";
import { ReactNode } from "react";
import { ExternalLinkIcon, HelpIcon } from "../../icons";
import { UnstyledLink } from "../link";

interface ContangoPillProps {
  contangoImage: ReactNode;
}

export function ContangoPill({
  contangoImage,
}: ContangoPillProps): JSX.Element {
  const variant = useDescriptionVariant();

  return (
    <Pill>
      Leverage with Contango{" "}
      {match(variant)
        .with("static", () => <ExternalLink href={LINKS.CONTANGO} />)
        .with("tooltip", () => (
          <UnstyledLink external href={LINKS.CONTANGO}>
            <TooltipDescription
              placement="right-start"
              trigger={
                <div className="flex items-center gap-2.5 text-shale-400">
                  <HelpIcon className={"w-4 h-4"} />

                  <ExternalLinkIcon className="w-4 h-4" />
                </div>
              }
            >
              <div className="flex flex-col gap-10">
                <div className="flex flex-col gap-5 text-shale-100">
                  <p>
                    This market allows you to auto-leverage via Contango, a
                    third party application built on Silo.
                  </p>

                  <p>
                    You may select a pair of tokens and leverage and Contango
                    contracts will automatically 'loop' to your desired
                    position.
                  </p>
                </div>

                {contangoImage}
              </div>
            </TooltipDescription>
          </UnstyledLink>
        ))
        .exhaustive()}
    </Pill>
  );
}
